import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-station-tile',
    templateUrl: './station-tile.component.html',
    styleUrls: ['./station-tile.component.scss'],
    standalone: false
})
export class StationTileComponent implements OnInit {

  @Input('styleClass') style: string;

  @Input() selected: boolean;

  @Input('isDisabled') disabled: boolean;

  @Input() suspended: boolean;

  @Input() height: number;

  constructor() {
  }

  ngOnInit(): void {
  }

}
